export const formatTimestamp = (timestamp?: number) => {
  if (!timestamp) return "";
  var a = new Date(timestamp * 1000);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var time = date + " " + month + " " + year;
  return time;
};

export const getJSDate = (utc: number, offsetDays: number = 0): Date => {
  if (!utc) return new Date(0) as any;
  if (utc > 99991231) utc = Math.floor(utc / 100);

  const year: number = Math.floor(utc / 10000);
  const month: number = Math.floor((utc % 10000) / 100);
  const day: number = utc % 100;

  const date: Date = new Date(year, month - 1, day, 12);

  if (offsetDays !== 0)
    date.setTime(date.getTime() + offsetDays * 24 * 3600 * 1000);

  date.setHours(0);
  return date;
};

export const utcAddDays = (utc: number, add: number = 0): number => {
  if (!utc) return 0;
  if (!add) return utc;

  const day: number = utc % 100;
  const newday = day + add;
  if (add > 0) {
    if (newday <= 28) return Math.floor(utc / 100) * 100 + newday;
  } else {
    if (newday >= 1) return Math.floor(utc / 100) * 100 + newday;
  }
  const dateAdded = getJSDate(utc, add);
  return getUtcDate(dateAdded);
};

export const getUtcDate = (
  date: Date = new Date(),
  offsetDays: number = 0
): number => {
  const d = new Date(date.getTime() + offsetDays * 24 * 3600 * 1000);
  const year: number = d.getFullYear();
  const month: number = d.getMonth() + 1;
  const day: number = d.getDate();
  return year * 10000 + month * 100 + day;
};

export const daysBetweenUtcDates = (utc1: number = 0, utc2: number = 0) => {
  if (utc1 === 0 || utc2 === 0) return 0;
  if (Math.abs(utc2 - utc1) <= 30) return utc2 - utc1; //both dates in same month

  const date1: Date = getJSDate(utc1);
  const date2: Date = getJSDate(utc2);
  const diffDays: number = Math.round(
    (date2.getTime() - date1.getTime()) / (24 * 3600 * 1000)
  );
  return diffDays;
};

export const getDateList = (
  utcStart: number,
  utcEndInclusive: number
): Date[] => {
  const count: number = daysBetweenUtcDates(utcStart, utcEndInclusive) + 1;
  const date: Date = getJSDate(utcStart);
  const list: Date[] = [new Date(date.valueOf())];

  for (var i: number = 1; i < count; i++) {
    date.setDate(date.getDate() + 1);
    list.push(new Date(date.valueOf()));
  }
  return list;
};

const defaults = {
  formatTimestamp,
  getJSDate,
  getUtcDate,
  daysBetweenUtcDates,
  getDateList,
  utcAddDays,
};

export default defaults;
